export enum DocumentTypes {
  CmsMa = "CmsMa",
  CmsMaContinued = "CmsMaContinued",
  CmsMmp = "CmsMmp",
  CmsMmpContinued = "CmsMmpContinued"
}
